/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetNotificationPreferencesRequest} from '@cash-web/protos/squareup/franklin/SetNotificationPreferencesRequestProto.pb'
import {SetNotificationPreferencesResponse} from '@cash-web/protos/squareup/franklin/SetNotificationPreferencesResponseProto.pb'


export const setNotificationPreferences = (request: SetNotificationPreferencesRequest, options?: CashRequestOptions) => post<SetNotificationPreferencesRequest, SetNotificationPreferencesResponse>("/2.0/cash/set-notification-preferences", request, {...options, rejectOnError: true })